module.exports = __webpack_public_path__ + "static/media/Bid.1a581039.mp3";